module.exports = __webpack_public_path__ + "img/logo7.6202fe0a.svg";